// extracted by mini-css-extract-plugin
export default {"compContainer":"animate_compContainer__Ae0s7","fadeInDefault":"animate_fadeInDefault__d5h+I","fadeIn":"animate_fadeIn__46vva"};